import { FC } from 'react';
import styled from 'styled-components';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';
import { TooltipContentProps } from 'ui/tooltip/types';
import { MessageNamesList } from './MessageNamesList';

const TruncateTextTooltipContent = styled(TooltipContent)`
  & > span:first-of-type {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    display: inline-block;
  }
`;

export const CustomTooltipContent: FC<TooltipContentProps & { names: string[] }> = ({
  names,
  ...rest
}) => {
  /*
    This is a workaround as applying a hidden overflow inadvertedly hides the tooltip arrow.
    This would not be necessary if the tooltipContent was inherently rendered inside a span or p for semantic reasons.
   */
  return (
    <TruncateTextTooltipContent {...rest}>
      <MessageNamesList names={names} />
    </TruncateTextTooltipContent>
  );
};
